import { Tab, Tabs, useTheme, alpha } from "@mui/material";
import { useTranslation } from "react-i18next";

const ThirdTabs = ({ selected, setSelected, options }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Tabs
      variant="scrollable"
      scrollButtons="auto"
      value={selected}
      onChange={(_, newValue) => setSelected(newValue)}
      TabIndicatorProps={{
        sx: { display: "none" },
      }}
      sx={{
        minHeight: "48px",
        "& .MuiTabs-flexContainer": {
          gap: 1,
        },
      }}>
      {options.map((o, i) => {
        const Icon = o.tabIcon;
        return (
          <Tab
            disableRipple
            key={i}
            label={t(o.label)}
            value={o.value}
            icon={Icon ? <Icon size={18} /> : null}
            iconPosition="start"
            sx={{
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: "13px",
              fontWeight: 700,
              minHeight: "44px",
              minWidth: "auto",
              paddingX: 2.5,
              borderRadius: 3,
              color: isDark ? alpha('#fff', 0.6) : alpha('#000', 0.6),
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              gap: 1,

              "&.Mui-selected": {
                bgcolor: isDark ? alpha(theme.palette.primary.main, 0.15) : alpha(theme.palette.primary.main, 0.12),
                color: theme.palette.primary.main,
                boxShadow: isDark
                  ? `0 4px 12px ${alpha('#000', 0.2)}`
                  : `0 4px 12px ${alpha(theme.palette.primary.main, 0.1)}`,
              },

              "&:hover": {
                bgcolor: isDark ? alpha('#fff', 0.05) : alpha('#000', 0.03),
                color: isDark ? '#fff' : '#000',
              },

              "& .MuiTab-iconWrapper": {
                margin: 0,
                transition: "transform 0.4s ease",
              },

              "&.Mui-selected .MuiTab-iconWrapper": {
                transform: "scale(1.1)",
              }
            }}
          />
        );
      })}
    </Tabs>
  );
};

export default ThirdTabs;
